/* A small radial burst of hue-coloured sparks from a point — the "shine" on a
   check-in. Pure CSS; mount with a fresh key to replay. */
import { type HueName } from '@habishine/client-core';

import { hueVar } from '../theme/hues';

export function Burst({ hue, count = 10 }: { hue: HueName; count?: number }) {
  return (
    <span className="pointer-events-none absolute inset-0 flex items-center justify-center" aria-hidden>
      {Array.from({ length: count }, (_, i) => {
        const a = (i / count) * Math.PI * 2;
        const d = 34 + (i % 3) * 8;
        return (
          <span
            key={i}
            className="burst-spark"
            style={{
              background: i % 2 ? hueVar(hue, 'c') : 'var(--frog)',
              ['--tx' as string]: `${Math.cos(a) * d}px`,
              ['--ty' as string]: `${Math.sin(a) * d}px`,
              animationDelay: `${(i % 3) * 20}ms`,
            }}
          />
        );
      })}
    </span>
  );
}
